import { Lightbulb } from 'lucide-react'
import { REPORT_EXAMPLES } from '../../utils/report-examples'

interface ReportExamplesProps {
  /** Clicar num exemplo preenche o título do formulário. */
  onPick: (title: string) => void
}

/**
 * Referência de "o que reportar aqui", em formato de FAQ: fica ABAIXO do
 * formulário e com todos os itens sempre visíveis — antes era um card
 * recolhível no meio dos campos, que interrompia o preenchimento e escondia
 * justamente a informação que ajuda a decidir o que escrever.
 *
 * Cada item continua clicável como atalho para preencher o título; é bônus,
 * não a função principal do bloco.
 */
export function ReportExamples({ onPick }: ReportExamplesProps) {
  return (
    <section
      aria-labelledby="report-examples-title"
      className="mt-2 border-t border-border-subtle pt-4"
    >
      <h3
        id="report-examples-title"
        className="mb-1 flex items-center gap-2 text-xs font-semibold text-body/80"
      >
        <Lightbulb className="h-3.5 w-3.5 shrink-0 text-amber-500" aria-hidden />
        Não sabe se é caso de reportar? Veja exemplos
      </h3>
      <p className="mb-3 text-[11px] text-subtle">
        Estes são problemas do sistema — falha ou comportamento inesperado do
        Hub. Pedido de melhoria tem fila própria em &quot;Fila de
        Solicitações&quot;. Clique num exemplo para usá-lo como título.
      </p>
      <dl className="divide-y divide-border-faint border-t border-border-faint">
        {REPORT_EXAMPLES.map((example) => (
          <div key={example.title}>
            <button
              type="button"
              onClick={() => onPick(example.title)}
              title="Usar como título"
              className="w-full rounded px-1 py-2 text-left transition hover:bg-surface-muted"
            >
              <dt className="text-xs font-medium text-body">{example.title}</dt>
              <dd className="mt-0.5 text-[11px] text-subtle">{example.hint}</dd>
            </button>
          </div>
        ))}
      </dl>
    </section>
  )
}
